<template>
  <div class="timeline-hero">
    <div class="timeline-grid-images">
      <div class="hero-grid">
        <div
          v-for="(img, idx) in arr"
          :key="idx"
          class="grid_item"
          :style="{
            '--r': img[0],
            '--c': img[1],
          }"
        >
          <!-- <div :ref="`grid-item-${idx}`" class="grid_item-inner"> -->
          <div :ref="`grid-img-${idx}`" class="grid_item-imgs">
            <div
              v-for="index in 2"
              :key="index"
              class="grid_item-img"
              :style="style()"
            ></div>
          </div>
          <!-- </div> -->
        </div>
      </div>
    </div>
    <div class="title-wrapper">
      <h3 class="f-title-4 title">Timeline <br /><span>1974-2024</span></h3>
      <ScrollIcon />
    </div>
  </div>
</template>
<script>
import gsap from "gsap";
import ScrollIcon from "./ScrollIcon.vue";
export default {
  components: {
    ScrollIcon,
  },
  data() {
    return {
      arr: [
        [1, 1],
        [1, 6],
        [2, 4],
        [3, 2],
        [2, 8],
        [4, 5],
        [5, 6],
        [5, 1],
        [3, 7],
        [6, 3],
        [7, 4],
        [7, 8],
      ],
      imgs: 34,
      rows: 5,
      cols: 8,
      gridRef: "grid_img",
      url: "https://ieamaps.blob.core.windows.net/50th-anniversary/grid/",
    };
  },
  mounted() {
    this.animate();
  },
  beforeDestroy() {
    let timelines = gsap.globalTimeline.getChildren();
    let gridTls = timelines.filter((d) => d.data === "grid-tl");
    gridTls.forEach((d) => d.kill());
  },

  methods: {
    animate() {
      const { arr } = this;
      /**
       * Image shrink
       */
      // arr.forEach((_, i) => {
      //   const item = this.$refs[`grid-item-${i}`];
      //   gsap.to(item, {
      //     scrollTrigger: {
      //       trigger: item,
      //       scroller: "#timeline",
      //       start: "top top",
      //       end: "bottom top",
      //       scrub: true,
      //     },
      //     ease: "none",
      //     scale: 0,
      //   });
      // });

      /**
       * Image transition
       */
      arr.forEach((_, i) => {
        const img = this.$refs[`grid-img-${i}`];
        const timeline = gsap.timeline({
          repeat: -1,
          repeatDelay: 1,
          data: "grid-tl",
        });
        timeline.to(img, {
          yPercent: -100,
          duration: 0.3,
          data: "first-anim",
          ease: "power1.out",
          delay: "random(0, 2)",
          stagger: {
            each: 0.1,
            from: "random",
          },
          onComplete: () => this.replaceImage(img),
        });
        timeline.to(img, {
          yPercent: 0,
          data: "first-anim",
          duration: 0,
        });
      });
      /**
       * Hero page transition
       */
      const heroTl = gsap.timeline({
        scrollTrigger: {
          trigger: ".timeline-hero",
          scroller: "#timeline",
          scrub: true,
          start: "10% top",
          end: "40% top",
          ease: "power1.out",
        },
      });
      heroTl.from(
        ".timeline-header",
        {
          backgroundColor: "#1b1b1b",
          borderColor: "#1b1b1b",
          color: "#fff",
        },
        0
      );
      heroTl.from(".timeline-hero", { backgroundColor: "#1b1b1b" }, 0);
      heroTl.from(".title", { color: "#fff" }, 0);
    },
    replaceImage(d) {
      const { url, imgs } = this;
      const parent = d[0];
      for (let i = 1; i < parent.childNodes.length; i++) {
        const randomImage = Math.floor(Math.random() * imgs + 1);
        let newImage = `url(${url}50-anniv-${randomImage}.png)`;
        parent.firstChild.style.backgroundImage = newImage;
        parent.insertBefore(parent.childNodes[i], parent.firstChild);
      }
    },
    style() {
      const { url, imgs } = this;
      const randomImage = Math.floor(Math.random() * imgs + 1);
      return `background-image: url(${url}50-anniv-${randomImage}.png)`;
    },
  },
};
</script>

<style>
.timeline-hero {
  width: 100%;
  min-height: calc(100vh - 60px);
  background: #fff;
  position: relative;
}
.timeline-grid-images {
  position: relative;
  /* z-index: 1; */
}
.hero-grid {
  width: 100%;
  display: grid;
  /* z-index: inherit; */
  /* position: relative; */
}
.grid_item {
  position: relative;
  grid-column: var(--c);
  grid-row: var(--r);
  width: 100%;
  height: auto;
  aspect-ratio: 1;
  overflow: hidden;
}
.grid_item-imgs {
  height: 100%;
}
.grid_item-img {
  position: relative;
  width: 100%;
  height: auto;
  aspect-ratio: 1;
  background-position: 50% 50%;
  background-size: cover;
  /* background-size: contain; */
  background-repeat: no-repeat;
}
.grid_item-overlay {
  width: 100%;
  height: 100%;
}
.title-wrapper {
  position: fixed;
  width: 100%;
  height: 100%;
  margin-top: 60px;
  top: 0;
  left: 0;
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  pointer-events: none;
  /* z-index: 0; */
  /* z-index: 2; */
}
.title {
  color: #000;
  text-align: center;
}
.title span {
  /* color: #04f; */
}
@media screen and (min-width: 1480px) {
  .hero-grid {
    grid-template-columns: repeat(8, 1fr);
  }
}
@media screen and (min-width: 1280px) and (max-width: 1479px) {
  .hero-grid {
    grid-template-columns: repeat(7, 1fr);
  }
}
@media screen and (min-width: 960px) and (max-width: 1279px) {
  .hero-grid {
    grid-template-columns: repeat(6, 1fr);
  }
}
@media screen and (min-width: 730px) and (max-width: 959px) {
  .hero-grid {
    grid-template-columns: repeat(4, 1fr);
  }
}
@media screen and (max-width: 729px) {
  .hero-grid {
    grid-template-columns: repeat(4, 1fr);
  }
}
</style>
